/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import Opaque from "App/render/webgl/nodes/bins/opaque_bin";
import WebGLRenderGraph from "App/render/webgl/render_graph";
import Pass from "App/render/webgl/passes/pass";
import Factory from "App/render/webgl/nodes/bins/factory";
import WebGLContext from "App/web_gl_context";
import Screen from "App/render/webgl/passes/screen";
import {AlphaTransparencyBinTypeName} from "App/render/webgl/nodes/bins/type_names";
import IScene from "js_interface/src/scene_interface";

export default
class AlphaTransparency extends Opaque {

    public static TypeName: string = AlphaTransparencyBinTypeName;

    constructor(aSceneAPI: IScene, aRenderGraph: WebGLRenderGraph) {
        super(aSceneAPI, aRenderGraph);
    }

    public static create(aSceneAPI: IScene, aRenderGraph: WebGLRenderGraph): AlphaTransparency {
        return new AlphaTransparency(aSceneAPI, aRenderGraph);
    }

    public render(aRenderPass: Pass): boolean {
        aRenderPass.bindShader(this._typeName);

        // TODO: not nice
        let passTypeName = aRenderPass.getClassTypeName();
        if (passTypeName === Screen.TypeName) {
            let gl = (this._context as WebGLContext).getWebGLRenderingContext();

            gl.depthFunc(gl.LESS);
            // first we render the alpha as opaque (for correct blending of objects itself)
            super.render(aRenderPass);

            // the we render again and blend
            // enable alpha blending
            gl.enable(gl.BLEND);
            gl.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE);
            gl.depthFunc(gl.LEQUAL);

            super.render(aRenderPass);

            gl.disable(gl.BLEND);
        } else {
            // TB: hack: do not blend during shadow volumes rendering
            super.render(aRenderPass);
        }

        aRenderPass.unbindShader();

        return true;
    }
}

Factory.register(AlphaTransparency);
